// extracted by mini-css-extract-plugin
export default {"scrollButtonsContainer":"ScrollButtons_scrollButtonsContainer__-oWaO","scrollButton":"ScrollButtons_scrollButton__Za55H","disabled":"ScrollButtons_disabled__48dpo"};